<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
			  <el-form-item>
				<el-input v-model="filters.groupName" placeholder="分类名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGroups">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="groups" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="group_code" label="分类编号" width="120">
			</el-table-column>
			<el-table-column prop="group_name" label="分类名称" width="120" >
			</el-table-column>
			<el-table-column prop="task_flag_name" label="作业相关"  width="120" >			
			</el-table-column>
			<el-table-column prop="use_flag_name" label="启用状态"  width="120" >			
			</el-table-column>
			
			<el-table-column label="操作" >
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[10, 20, 30, 40,50]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
			    <el-form-item label="上级分类" prop="parent_code">
					 <el-select v-model="editForm.parent_code"  placeholder="请选择" >
                        <el-option  v-for="(item,index) in parents" :key="index"  :label="item.group_name"  :value="item.group_code"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item label="分类编号" prop="group_code">
				     <el-input v-model="editForm.group_code" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="分类名称" prop="group_name">
					 <el-input v-model="editForm.group_name" auto-complete="off" ></el-input>
				</el-form-item>	
				<el-form-item label="排序" prop="sort">
					 <el-input v-model.number="editForm.sort" auto-complete="off" ></el-input>
				</el-form-item>	
				<el-form-item>					
					 <el-checkbox v-model="editForm.task_flag">作业相关</el-checkbox>
					 <el-checkbox v-model="editForm.use_flag">启用</el-checkbox>						
			    </el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getDiscoveryGroupListPage,addDiscoveryGroup,editDiscoveryGroup,removeDiscoveryGroup,batchRemoveDiscoveryGroup,getParentGroup } from '../../api/api';
   
  

 let CurrentUserID="",Session=""; 
	export default {
	
		data() {
			return {
				
				filters: {
					
					groupName:''

				},
				parents: [],
				groups: [],
				total: 0,
				pageSize:10,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					group_code: [
						{ required: true, message: '请输入分类编号', trigger: 'blur' }
					],
					group_name: [
						{ required: true, message: '请输入分类名称', trigger: 'blur' }
					],
					sort:[
							{ required: false, message: '排序不能为空'},
							{ type: 'number', message: '排序必须为数字值'}
						 ]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					group_name: '',
					group_code:'',
					parent_code:'',
					task_flag:false,
					use_flag:false,
					sort:''
				},

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getGroups();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getGroups();
			
			},
			getParent(){
             	this.$http.jsonp(getParentGroup,{params: {CurrentUserID:CurrentUserID,Session:Session }}).then(
		        	function(res){                         
						if (res.data.result_code==200)
						{						
							this.parents=res.data.parents;					
						}
						else{                           
							this.$message({
							message:'获取上级分类错误',
							type: 'error'
							});
						}
					},
					function(res)
					{
						this.$message({
								message:'获取上级分类错误',
								type: 'error'
								});
						
					}
				);


			},
			//获取列表
			getGroups() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					groupName:this.filters.groupName,				
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getDiscoveryGroupListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.grouplist.total;
					         this.groups = res.data.grouplist.groups;
					         this.listLoading = false;
                           
                         }
                         else{   
							  this.listLoading = false;
                              if (res.data.result_code==911)
							  {

                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
								this.$message({
									message:'接口错误',
									type: 'error'
								});

							  }

                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                       this.listLoading = false;
                   }
           )






			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session};


                   this.$http.jsonp(removeDiscoveryGroup, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getGroups();
                           
                         }
                         else{  

							 this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有权限删除',
                                type: 'error'
                              });
							}

                            
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                     this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
	
				this.formStatus=1;
				this.editFormVisible = true;
			    this.editForm = {
					id: 0,
					group_name: '',
					group_code:'',
					parent_code:'',
					task_flag:false,
					use_flag:false,
					sort:''
				};
				
				this.editForm = Object.assign({}, row);     


				this.editForm.task_flag=this.editForm.task_flag>0?true:false;    

				this.editForm.use_flag=this.editForm.use_flag>0?true:false;      
			  
				//this.$refs['editForm'].resetFields();
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				
				this.editForm = {
					id: 0,
					group_name: '',
					group_code:'',
					parent_code:'',
					task_flag:false,
					use_flag:false,
					sort:''
				};
				if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }		
               //this.$refs['editForm'].resetFields();
				
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;

			   let paramUrl=addDiscoveryGroup;			  
               if (this.formStatus==1)
			   {
                  paramUrl=editDiscoveryGroup;
			   }
                this.$http.jsonp(paramUrl, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    
							   		this.editForm = {
										id: 0,
										group_name: '',
										group_code:'',
										parent_code:'',
										task_flag:false,
										use_flag:false,
										sort:''
									};
							    if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getGroups();
                           
                         }
                         else{                           
                            
							 this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getGroups();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };


                   this.$http.jsonp(batchRemoveDiscoveryGroup, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getGroups();
                           
                         }
                         else{                           
                                this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
	              
            this.getParent();
			this.getGroups();


		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// group.vue?26eec3b8